"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _input = _interopRequireDefault(require("../input"));

var _dropdown = _interopRequireDefault(require("../dropdown"));

var _messages = _interopRequireDefault(require("../select/messages"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var cx = _bind["default"].bind(_style["default"]);

var SelectMultiple = function SelectMultiple(_ref) {
  var intl = _ref.intl,
      input = _ref.input,
      fields = _ref.fields,
      options = _ref.options,
      searchable = _ref.searchable,
      autosize = _ref.autosize,
      placeholder = _ref.placeholder,
      rest = _objectWithoutProperties(_ref, ["intl", "input", "fields", "options", "searchable", "autosize", "placeholder"]);

  var selectedItems = fields.getAll() || [];
  return /*#__PURE__*/_jsx("div", {
    className: cx('xsui-select')
  }, void 0, /*#__PURE__*/_jsx(_dropdown["default"], {
    appearance: "secondary",
    options: options.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        active: selectedItems.includes(item.value)
      });
    }),
    value: input.value || null,
    size: rest.size,
    searchable: searchable,
    autosize: autosize,
    fullWidth: true,
    autohide: false,
    separated: false,
    onChange: function onChange(value) {
      selectedItems.includes(value) ? fields.remove(selectedItems.indexOf(value)) : fields.push(value);
    }
  }, void 0, /*#__PURE__*/_react["default"].createElement(_input["default"], _extends({}, rest, {
    input: {
      name: input.name || rest.name,
      value: options.length > 0 ? selectedItems.map(function (value) {
        var option = options.find(function (option) {
          return option.value === value;
        });

        if (!option) {
          return null;
        }

        return option.label;
      }).join(', ') : '',
      onChange: function onChange() {
        return void 0;
      }
    },
    offset: "right",
    icon: "dropdown-select",
    placeholder: placeholder || intl.formatMessage(_messages["default"].placeholder),
    readOnly: true
  }))));
};

SelectMultiple.defaultProps = {
  input: {},
  fields: {},
  meta: {
    touched: false,
    error: null
  },
  size: 'md',
  options: [],
  searchable: false,
  autosize: false,
  disabled: false
};

var _default = (0, _reactIntl.injectIntl)(SelectMultiple);

exports["default"] = _default;